import initSettingModal from './modal.js'
import PasswordStrengthMeter from './password-strength.js'

/**
 * 設定画面のパスワード関連機能の初期化
 */
$(document).on('turbolinks:load', () => {
  initPasswordModal()
})

/**
 * パスワードモーダルの初期化
 */
const initPasswordModal = () => {
  const {
    onClickOpenEditModals,
    onClickCloseModal,
  } = initSettingModal({ target: 'password' })

  onClickOpenEditModals()
  onClickCloseModal()

  initPasswordStrengthMeter()
}

/**
 * パスワード強度メーターの初期化とDOM監視の設定
 */
const initPasswordStrengthMeter = () => {
  let observer = null

  /**
   * メーターの初期化実行
   */
  const initMeter = () => {
    const passwordInput = findPasswordInput()
    const meterContainer = document.querySelector('.password-meter-container')

    if (passwordInput && meterContainer && !passwordInput.dataset.meterInitialized) {
      new PasswordStrengthMeter(passwordInput, meterContainer)
      passwordInput.dataset.meterInitialized = 'true'

      if (observer) {
        observer.disconnect()
      }
    }
  }

  /**
   * パスワード入力フィールドを検索
   */
  const findPasswordInput = () => {
    return document.querySelector('input[name="user[password]"]') ||
           document.querySelector('#user_password') ||
           document.querySelector('input[type="password"]:not([name*="current"]):not([name*="confirmation"])')
  }

  /**
   * DOM変更監視の設定
   */
  const setupObserver = () => {
    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              requestAnimationFrame(initMeter)
            }
          })
        }
      })
    })

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      })
    }
  }

  // イベントリスナーの設定
  $(document).on('click', '[class*="js-password-edit-btn"]', () => {
    setTimeout(initMeter, 300)
  })

  $(document).on('shown.bs.modal', '[id*="modalPassword"]', () => {
    setTimeout(initMeter, 100)
  })

  // 初期化とオブザーバー設定
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMeter)
  } else {
    requestAnimationFrame(initMeter)
  }

  setupObserver()
}

const getBrandId = (element, prefix) => {
  const classNames = element.attr('class').split(' ')
  const elementId = classNames.find(className =>
    className.includes(prefix)
  )

  return elementId.replace(prefix, '')
}
